module.exports = __webpack_public_path__ + "static/media/single-choice.3e5c8b93.svg";